import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ApiService } from '@env-lib/api/api.service'
import { SignUpRequestBody } from '@landing-page/sign-up/sign-up.model'

import { Observable } from 'rxjs'

export interface SignupData {
    firstName: string
    lastName: string
    email: string
    company: string
    phoneNumber?: string
    dataPrivacyAccepted: boolean
}

@Injectable({
    providedIn: 'root',
})
export class SignUpService {
    constructor(
        private api: ApiService,
        private http: HttpClient
    ) {}

    sendSignUpRequest(
        formData: SignupData,
        isDemoRequested: boolean
    ): Observable<void> {
        return this.http.post<void>(
            `${this.api.userInterest.backendUrl}/users/interest`,
            {
                company: formData.company.trim(),
                email: formData.email.trim(),
                firstName: formData.firstName.trim(),
                lastName: formData.lastName.trim(),
                phoneNumber: formData.phoneNumber
                    ? formData.phoneNumber?.trim()
                    : undefined,
                dataPrivacyAccepted: formData.dataPrivacyAccepted,
                demoRequested: isDemoRequested,
            } as SignUpRequestBody
        )
    }
}
